import React, {useMemo} from 'react';
import {cn, toPriceStr} from '@utils';
import {LeaderboardItemType} from '@/common-pages/leaderboard/types';

interface TopItemType {
  crown: any;
  bg: any;
  rank: number;
  username: string;
  score?: number;
  avatar?: string;
  bonus?: number;
  point?: number;
  style: {
    height: string;
    width: string;
    paddingTop: string;
    marginTop?: string;
  };
}

const crown1 = require('../../assets/top-1.webp');
const crown2 = require('../../assets/top-2.webp');
const crown3 = require('../../assets/top-3.webp');
const topbg1 = require('../../assets/top-1-bg.webp');
const topbg2 = require('../../assets/top-2-bg.webp');
const topbg3 = require('../../assets/top-3-bg.webp');
const defaultUser =
  require('@/common-pages/leaderboard/assets/user-default-2.svg').default;
const RANK_CONFIG: TopItemType[] = [
  {
    crown: crown2,
    bg: topbg2,
    rank: 2,
    username: '',
    style: {
      height: '7.625rem',
      width: '6.5rem',
      marginTop: '1.375rem',
      paddingTop: '1.55rem',
    },
  },
  {
    crown: crown1,
    bg: topbg1,
    rank: 1,
    username: '',
    style: {
      height: '8.5rem',
      width: '7.125rem',
      paddingTop: '1.75rem',
    },
  },
  {
    crown: crown3,
    bg: topbg3,
    rank: 3,
    username: '',
    style: {
      height: '7.625rem',
      width: '6.5rem',
      marginTop: '1.375rem',
      paddingTop: '1.55rem',
    },
  },
];

function Top({data}: {data: LeaderboardItemType[]}) {
  const topThreeData = useMemo((): TopItemType[] => {
    const dataMap = new Map(data.map(item => [item.rank, item]));

    return RANK_CONFIG.map(item => {
      const matchedData = dataMap.get(item.rank);
      return matchedData
        ? {
            ...item,
            username: matchedData.username || item.username,
            avatar: matchedData.avatar,
            bonus: matchedData.bonus,
            point: matchedData.point,
          }
        : item;
    });
  }, [data]);
  return (
    <div className="relative flex justify-between mx-[14.5px] mt-3 pt-9">
      {topThreeData.map(item => {
        return (
          <div
            className={cn(
              'bg-full flex flex-col items-center text-[0.625rem] relative',
            )}
            key={item.rank}
            style={{
              backgroundImage: `url(${item.bg})`,
              ...item.style,
            }}>
            <div
              className="rounded-full size-12 border-2 border-white absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 bg-full"
              style={{
                backgroundImage: `url(${item.avatar || defaultUser})`,
              }}>
              <div
                className="w-[2.125rem] h-[1.875rem] absolute left-1/2 top-0 bg-full -translate-y-1/2 "
                style={{
                  backgroundImage: `url(${item.crown})`,
                }}
              />
            </div>
            <div className={cn('top' + item.rank)}>{'top' + item.rank}</div>
            <div className="text-t2 font-medium">{item.username}</div>
            <div className="text-black font-bold">
              <div>
                Bonus:{' '}
                {toPriceStr(item.bonus, {suffixUnit: 'K', overPrice: 10000})}
              </div>
              <div>
                Point:{' '}
                {toPriceStr(item.point, {
                  showCurrency: false,
                  suffixUnit: 'K',
                  overPrice: 10000,
                })}
              </div>
              {item.score && !item.bonus && !item.point && (
                <div>Score: ₹{item.score}</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Top;
